
import DevConfirmationModalTest from "./dev/DevConfirmationModalTest";
import { EnrollmentSequence } from "./components/Sequence/EnrollmentSequence";
import ApplyPage from "./components/Pages/ApplyPage";
import LogOut from "./components/Pages/LogOut";
import IndexPage from "./components/Pages/IndexPage";
import TestPage from "./tests/TestPage";
import PaymentComplete from "./components/Pages/PaymentComplete";
import ConfirmationPage from "./components/Pages/ConfirmationPage";
import AgreementToDoBusiness from "./components/Pages/AgreementToDoBusiness";
import ResetPassword from "./components/Forms/ResetPassword";
import UiStencil from "./components/Pages/UiStencil";
import TermLifeSpecialOfferExpiredPage from "./components/Pages/TermLifeSpecialOfferExpiredPage";

// Development-only routes
const devRoutes = process.env.NODE_ENV !== "production"
  ? [{ path: "/dev-confirmation-modal-test", element: <DevConfirmationModalTest /> }]
  : [];






const AppRoutes: Array<any> = [
    ...devRoutes,
    {
      path: '/test',
      element: <TestPage/>,
    },
    {
        path: '/stencil',
        element: <UiStencil />
    },
    {
        path: '/agreement-to-do-business-with-gallagher',
        element: <AgreementToDoBusiness />
    },
    {
        path: '/confirmation',
        element: <ConfirmationPage/>,
    },
    {
        // ODR-2863: special offer has expired; static path outranks /apply/:productKey.
        path: '/apply/term-life-special-offer',
        element: <TermLifeSpecialOfferExpiredPage />
    },
    {
      path: '/apply/:productKey',
      element: <ApplyPage />
    },
    {
        path: '/:productKey',
        element: <EnrollmentSequence sponsor="American Federation of Teachers" />
    },
    {
        path: ':productKey/payment-complete',
        element: <PaymentComplete />
    },
    {
        path: '/logout',
        element: <LogOut />
    },
    {
        path: '/',
        element: <IndexPage />,
        index: true
    },
    {
        path: '/reset-password/:token',
        element: <ResetPassword />,
        index: true
    }
];

export default AppRoutes;